var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfFile = function SvgPdfFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.625 0 7.5 1.125 7.5 2.5V37.5C7.5 38.875 8.625 40 10 40H35C36.375 40 37.5 38.875 37.5 37.5V10L27.5 0H10Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H37.5L27.5 0V7.5C27.5 8.875 28.625 10 30 10Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 17.5L30 10H37.5V17.5Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 32.5C32.5 33.1875 31.9375 33.75 31.25 33.75H3.75C3.0625 33.75 2.5 33.1875 2.5 32.5V20C2.5 19.3125 3.0625 18.75 3.75 18.75H31.25C31.9375 18.75 32.5 19.3125 32.5 20V32.5Z",
    fill: "#F15642"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94873 23.6861C7.94873 23.3561 8.20873 22.9961 8.62748 22.9961H10.9362C12.2362 22.9961 13.4062 23.8661 13.4062 25.5336C13.4062 27.1136 12.2362 27.9936 10.9362 27.9936H9.26748V29.3136C9.26748 29.7536 8.98748 30.0023 8.62748 30.0023C8.29748 30.0023 7.94873 29.7536 7.94873 29.3136V23.6861ZM9.26748 24.2548V26.7448H10.9362C11.6062 26.7448 12.1362 26.1536 12.1362 25.5336C12.1362 24.8348 11.6062 24.2548 10.9362 24.2548H9.26748Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3638 30.0041C15.0338 30.0041 14.6738 29.8241 14.6738 29.3854V23.7079C14.6738 23.3491 15.0338 23.0879 15.3638 23.0879H17.6526C22.2201 23.0879 22.1201 30.0041 17.7426 30.0041H15.3638ZM15.9938 24.3079V28.7854H17.6526C20.3513 28.7854 20.4713 24.3079 17.6526 24.3079H15.9938Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7401 24.3852V25.974H26.2889C26.6489 25.974 27.0089 26.334 27.0089 26.6827C27.0089 27.0127 26.6489 27.2827 26.2889 27.2827H23.7401V29.3815C23.7401 29.7315 23.4914 30.0002 23.1414 30.0002C22.7014 30.0002 22.4326 29.7315 22.4326 29.3815V23.704C22.4326 23.3452 22.7026 23.084 23.1414 23.084H26.6501C27.0901 23.084 27.3501 23.3452 27.3501 23.704C27.3501 24.024 27.0901 24.384 26.6501 24.384H23.7401V24.3852Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 33.75H7.5V35H31.25C31.9375 35 32.5 34.4375 32.5 33.75V32.5C32.5 33.1875 31.9375 33.75 31.25 33.75Z",
    fill: "#CAD1D8"
  })));
};
export default SvgPdfFile;